<template>
  <b-autocomplete
    v-model="searchText"
    :disabled="!isActive"
    field="name"
    :data="searchResults"
    icon="search"
    icon-pack="fas"
    clearable
    open-on-focus
    :placeholder="placeholder"
    :loading="loading"
    custom-class="importantWhite blackBorder !tw-bg-[#F6F7F8]"
    @typing="search"
    @select="select"
  >
    <template slot-scope="props">
      <div class="media">
        <div class="media-content">
          {{ props.option.first_name }} {{ props.option.last_name }}
        </div>
      </div>
    </template>
    <template slot="empty">
      <div v-if="!loading">
        No results found
      </div>
      <div v-if="loading">
        Searching...
      </div>
    </template>
  </b-autocomplete>
</template>

<script>
import _ from 'lodash';

export default {
  props: {
    select: Function,
    placeholder: String,
    initialText: String,
    isActive: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      searchText: this.initialText || '', // Initialize with initialText if provided
      searchResults: [],
      loading: false,
      currentSearchId: 0,
    };
  },
  watch: {
    searchText: {
      handler(newValue) {
        if (newValue) {
          this.search();
        } else {
          this.searchResults = [];
          this.loading = false;
        }
      },
    },
    initialText: {
      handler(newValue) {
        this.searchText = newValue;
      },
    },
  },
  created() {
    this.debouncedSearch = _.debounce(this.doSearch, 400);
  },
  methods: {
    search() {
      this.loading = true;
      this.currentSearchId++;
      this.debouncedSearch(this.currentSearchId);
    },
    async doSearch(searchId) {
      try {
        const queryParams = new URLSearchParams({ search: this.searchText });
        const url = `/api/v1/prospects/?${queryParams}`;
        const response = await fetch(url);

        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        const data = await response.json();

        // Only update results if this is still the most recent search
        if (searchId === this.currentSearchId) {
          this.searchResults = data.prospects || [];
          this.loading = false;
        }
      } catch (error) {
        console.error('Search error:', error);
        if (searchId === this.currentSearchId) {
          this.searchResults = [];
          this.loading = false;
        }
      }
    },
  },
};
</script>
